import {
  ElDialog,
  ElIcon,
  ElCarousel,
  ElCarouselItem,
  ElLink,
  ElTooltip,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElButton
} from "element-plus";
import baseApp from "./../innerAPP";
import "./../css/home.css";
import App from "./App";
const vm = baseApp(App);
vm.use(ElDialog)
  .use(ElIcon)
  .use(ElCarousel)
  .use(ElCarouselItem)
  .use(ElLink)
  .use(ElTooltip)
  .use(ElDropdown)
  .use(ElDropdownMenu)
  .use(ElDropdownItem)
  .use(ElButton)
vm.mount("#app");
